export const ApiRoutes = {
  getProjects: '/projects',
  getProject: '/project/{id}',
  getSnippet: '/snippet/{id}',
  createSnippet: '/snippet',
  getSnippets: '/snippets',
  getRoute: '/project/{projectId}/route/{routeId}',
  getRoutes: '/project/{projectId}/routes',
  runCode: '/code/run',
  getConnectors: '/connectors',
  getModules: '/modules',
  getTrialInfo: '/billingEntities/trial-info',
  getClients: '/clients',
  getRouteTemplates: '/templates/routes',
  getRouteTemplate: '/templates/routes/{templateId}',
}

export const ZendeskRoutes = {
  getWebhooks: '/webhooks',
  createWebhook: `/webhooks`,
  getTriggerCategories: '/trigger_categories',
  createTriggerCategory: '/trigger_categories',
  getTriggers: '/triggers',
  createTrigger: '/triggers',
  getCustomObjects: '/custom_objects',
  getCustomObjectFields: '/custom_objects/:customObjectKey/fields',
  getTicketFields: '/ticket_fields',
  getViews: '/views',
}
